export default __webpack_public_path__ + "static/media/snapshotsc.710abad5.png";